import { SvgIcon, SvgIconProps } from '@mui/material';

const CreditCoin = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="fi_17301413" clipPath="url(#clip0_8099_10049)">
          <path
            id="Vector"
            d="M10 20.4995C15.5228 20.4995 20 16.0224 20 10.4995C20 4.97666 15.5228 0.499512 10 0.499512C4.47715 0.499512 0 4.97666 0 10.4995C0 16.0224 4.47715 20.4995 10 20.4995Z"
            fill="#FFB703"
          />
          <path
            id="Vector_2"
            d="M10 17.6772C13.9642 17.6772 17.1777 14.4637 17.1777 10.4995C17.1777 6.53536 13.9642 3.32178 10 3.32178C6.03585 3.32178 2.82227 6.53536 2.82227 10.4995C2.82227 14.4637 6.03585 17.6772 10 17.6772Z"
            fill="#FFCC29"
          />
          <path
            id="Vector_3"
            d="M11.8568 9.78355L10.1049 7.24801C10.0932 7.23101 10.0776 7.2171 10.0594 7.2075C10.0411 7.19789 10.0208 7.19287 10.0002 7.19287C9.97959 7.19287 9.95928 7.19789 9.94104 7.2075C9.9228 7.2171 9.90718 7.23101 9.89552 7.24801L8.14356 9.78355C8.12678 9.80801 8.10199 9.82585 8.07346 9.83398C8.04493 9.84211 8.01447 9.84002 7.98731 9.82809L5.50137 8.72379C5.47918 8.71404 5.45467 8.71081 5.4307 8.71447C5.40674 8.71813 5.38431 8.72854 5.36604 8.74447C5.34777 8.76041 5.33441 8.78121 5.32753 8.80446C5.32064 8.8277 5.32051 8.85243 5.32716 8.87574L6.76856 13.8117C6.77626 13.8382 6.79234 13.8614 6.81439 13.878C6.83643 13.8945 6.86326 13.9035 6.89083 13.9035H13.11C13.1375 13.9035 13.1644 13.8945 13.1864 13.878C13.2085 13.8614 13.2245 13.8382 13.2322 13.8117L14.6736 8.87574C14.6803 8.85243 14.6802 8.8277 14.6733 8.80446C14.6664 8.78121 14.653 8.76041 14.6348 8.74447C14.6165 8.72854 14.5941 8.71813 14.5701 8.71447C14.5461 8.71081 14.5216 8.71404 14.4994 8.72379L12.0135 9.82809C11.9862 9.8399 11.9558 9.84191 11.9272 9.8338C11.8987 9.82568 11.8738 9.80793 11.8568 9.78355Z"
            fill="#F99300"
          />
        </g>
        <defs>
          <clipPath id="clip0_8099_10049">
            <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default CreditCoin;
